var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStyleOriginalRoundFalse1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.03705 11.2933C8.23854 8.59137 12.3738 6.81013 14.4429 5.94952C20.3507 3.4923 21.5782 3.06545 22.3783 3.05136C22.5543 3.04826 22.9478 3.09187 23.2027 3.29868C23.4179 3.47331 23.4771 3.70921 23.5054 3.87478C23.5338 4.04035 23.569 4.41752 23.541 4.71222C23.2209 8.07597 21.8356 16.2389 21.1309 20.0063C20.8327 21.6005 20.2455 22.135 19.6771 22.1873C18.4417 22.301 17.5036 21.3709 16.3071 20.5866C14.4348 19.3593 13.3771 18.5953 11.5597 17.3976C9.45943 16.0136 10.821 15.2529 12.0179 14.0097C12.3312 13.6843 17.7742 8.73347 17.8795 8.28435C17.8927 8.22818 17.9049 8.01881 17.7806 7.90825C17.6562 7.79769 17.4726 7.8355 17.3401 7.86557C17.1523 7.90819 14.1613 9.88513 8.36707 13.7964C7.51808 14.3794 6.74909 14.6634 6.0601 14.6485C5.30055 14.6321 3.83948 14.2191 2.75332 13.866C1.4211 13.433 0.36228 13.204 0.45448 12.4686C0.502503 12.0855 1.03003 11.6937 2.03705 11.2933Z",
    fill: "url(#paint0_linear_1_2379)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_2379",
    x1: 12.0001,
    y1: 3.05121,
    x2: 12.0001,
    y2: 22.0548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStyleOriginalRoundFalse1);
export default __webpack_public_path__ + "static/media/Style=Original, Round=False (1).11f2a97e7056d0b44a6ffeab37c5d3bb.svg";
export { ForwardRef as ReactComponent };